export const getLanguageCode = (lang) => {
    if(lang == 'English') return 'en_us'
    else return 'es_419'
}

export const getLanguage = (selectedLang) => {
    if(selectedLang == 'es_419') return 'Espanol'
    else return 'English'
}
